import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import AddVehicle from "./pages/AddVehicle";
import Inventory from "./pages/Inventory";
import Rentals from "./pages/Rentals";
import SalesHistory from "./pages/SalesHistory";
import Analytics from "./pages/Analytics";
import Expenses from "./pages/Expenses";
import Members from "./pages/Members";
import Portal from "./pages/Portal";
import Subscription from "./pages/Subscription";
import { PaymentSuccess, PaymentCancel, IyzicoCallback } from "./pages/Payment";
import { DistanceSale, RefundPolicy, Privacy, UserAgreement, KVKK } from "./pages/Legal";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-stone-500">
        Yükleniyor…
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/giris" replace state={{ from: location }} />;
  }
  return children;
}

function AdminOnly({ children }) {
  const { user } = useAuth();
  if (user?.role !== "admin") {
    return <Navigate to="/ozet" replace />;
  }
  return children;
}

function PortalOnly({ children }) {
  const { user } = useAuth();
  if (!user?.is_portal_owner) {
    return <Navigate to="/ozet" replace />;
  }
  return children;
}

function App() {
  useEffect(() => {
    document.title = "Oto Galeri & Kiralama Yönetim Paneli";
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          position="top-right"
          richColors
          toastOptions={{
            style: { fontFamily: "Karla, sans-serif" },
          }}
        />
        <Routes>
          <Route path="/giris" element={<Login />} />
          <Route path="/kayit" element={<Register />} />
          <Route path="/mesafeli-satis-sozlesmesi" element={<DistanceSale />} />
          <Route path="/iptal-iade" element={<RefundPolicy />} />
          <Route path="/gizlilik" element={<Privacy />} />
          <Route path="/kullanici-sozlesmesi" element={<UserAgreement />} />
          <Route path="/kvkk" element={<KVKK />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="ozet" element={<Dashboard />} />
            <Route path="arac-ekle" element={<AddVehicle />} />
            <Route path="stok" element={<Inventory />} />
            <Route path="kiralama" element={<Rentals />} />
            <Route path="satis-gecmisi" element={<SalesHistory />} />
            <Route path="analiz" element={<Analytics />} />
            <Route path="giderler" element={<Expenses />} />
            <Route path="uyeler" element={<AdminOnly><Members /></AdminOnly>} />
            <Route path="abonelik" element={<Subscription />} />
            <Route path="odeme/basarili" element={<PaymentSuccess />} />
            <Route path="odeme/iyzico-callback" element={<IyzicoCallback />} />
            <Route path="odeme/iptal" element={<PaymentCancel />} />
            <Route path="portal" element={<PortalOnly><Portal /></PortalOnly>} />
            <Route path="*" element={<Navigate to="/ozet" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
